// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { editOurService, getOurServiceById } from "../../../features/ourServices";

const EditOurService = () => {
  const { id } = useParams<{ id: string }>();
  const { ourService, status } = useSelector((state: any) => state.ourService);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "", // Room service name
    description: "", // Description for the room service (string format)
    photo: null, // Image for the room service
  });

  useEffect(() => {
    // Fetch room service data by ID
    dispatch(getOurServiceById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (status && ourService) {
      const data = ourService.data;
      setFormData({
        name: data.name,
        description: data.description,
        photo: data.photo,
      });
    }
  }, [status, ourService]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleThumbnailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        photo: e.target.files[0], // Handle photo image change
      }));
    }
  };

  const handleSubmit = () => {
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value); // Append name, description, photo
      }
    });

    dispatch(editOurService({ id, updatedOurService: formDataFinal }))
      .then((res: any) => {
        toast.success("Room Service updated successfully!");
        navigate("/our-service"); // Redirect to room service list or another page
      })
      .catch((err: any) => {
        console.error(err, "error");
        toast.error("An error occurred while updating the room service.");
      });
  };

  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      {/* Form Container */}
      <SoftBox width="100%" maxWidth="400px">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Edit Room Service
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Name Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="name"
              placeholder="Enter the room service name"
              value={formData.name}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Description Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Description
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="description"
              placeholder="Enter the room service description"
              value={formData.description}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Photo Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Photo
              </SoftTypography>
            </SoftBox>
            {formData.photo && (
              <img
                src={formData.photo.name ? URL.createObjectURL(formData.photo) : formData.photo}
                alt="Service"
                style={{ width: "150px", height: "150px", borderRadius: "5px" }}
              />
            )}
            <input
              type="file"
              name="photo"
              onChange={handleThumbnailChange}
              style={{ width: "100%" }}
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="info" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditOurService;
